import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const approvalRecommendationFilter = (): FilterDefinition => ({
  label: i18n.t('expenses_v2.list.filters.approval_recommendation_type.title'),
  type: 'in',
  options: {
    options: [
      {
        label: i18n.t('expenses_v2.list.filters.approval_recommendation_type.approve'),
        value: 'approve',
      },
      {
        label: i18n.t('expenses_v2.list.filters.approval_recommendation_type.reject'),
        value: 'reject',
      },
      {
        label: i18n.t('expenses_v2.list.filters.approval_recommendation_type.review'),
        value: 'review',
      },
    ],
  },
})
